module.exports = __webpack_public_path__ + "img/invoices_active.67062910.svg";